import { createSlice } from "@reduxjs/toolkit";


const loginSlice = createSlice({
  name: 'login',
  initialState: {
    login: null,
    isLoading: false,
    error: null
  },
  reducers: {
    signInSuccess: (state, action) => {
      state.isLoading = false;
      state.login = action.payload;
      state.error = null;
    },
  }
})

export const {
  signInSuccess
} = loginSlice.actions;


export default loginSlice.reducer;